import React from 'react'

const Search = () => {
    return (
        <div className='flex items-center justify-between border rounded-full sm:w-[300px] w-full py-2 px-4'>
            <input 
            type="text" 
            placeholder='Search...' 
            className='border-none outline-none'
            />
            <div className='bg-primary w-[30px] h-[30px] flex items-center justify-center rounded-full text-white'>
                <i className="uil uil-search"></i>
            </div>
        </div>
    )
}

export default Search